import { useEffect } from "react";
import fetchSubscription from "../../helpers/fetchSubscription";
import { useUserStore } from "../../store/zustand/useUserStore";

const UserSubscriptionProvider = ({
  children
}) => {
  const user = useUserStore((state) => state.user);
  useEffect(() => {
    if (user) {
      fetchSubscription();
    }
  }, []);

  return children;
};

export default UserSubscriptionProvider;
